import React from 'react';
import { useSponsoredProducts } from 'hooks';

const withSponsoredProducts = Component => props => {
    const [data] = useSponsoredProducts();
    return <Component {...props} sponsoredProducts={data} />;
};

export default withSponsoredProducts;
